import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';

const GradebookButton = ({ gradebookUrl }) => (
  <a
    className="NewButton NewButton--white NewButton--center undecorated c-brand-gray-darker"
    href={gradebookUrl}
  >
    <Icon name="table" className="mr-8 c-brand-gray-dark" />
    {t('gradebook.view')}
  </a>
);

const mapStateToProps = ({ pathBuilder }) => ({
  gradebookUrl: pathBuilder.urls.gradebook,
});

export default connect(mapStateToProps)(GradebookButton);
